import $ from "jquery"
import CryptoJS from "crypto-js";
import shareds from "./shared";
const shared = new shareds();

class ApiService {
    //物件建立時產生
    constructor(){
        this.url = process.env.VUE_APP_API_URL
        this.base_url = process.env.VUE_APP_BASE_API_URL
        console.log("process.env:",process.env)
        this.key = 'c4e1u12d45e83f78535dkb86bah50f4a'
        this.header = {
            // Cookie:"ci_session=6a1j400620fse2p6jfovgnu7hmcbgtao"
        }
        this.isDecryption = false
        this.userData = {}
        this.token = ""
    }

    init(data){ //初始化header
        console.log('api init data :' ,data)
        // this.userData = data
        this.header = {
            token:data.token
        }
        // this.key = this.getUserToken(data.token)
        console.log('this.key=',this.key)
    }
    //user Token 處理成32長度
    getUserToken(token){
        console.log('getUserToken token->',token)
        let hToken = token.substr(0,16)
        console.log('getUserToken hToken ['+hToken.length+']->',hToken)
        let fToken = token.substr(token.length-16,token.length)
        console.log('getUserToken hToken ['+fToken.length+']->',fToken)
        return hToken+fToken
    }
    setToken(token){
        this.token = token;
        this.header = {
            token: this.token
        }
    }
    getToken(){
        return this.token;
    }
    //解密
    AES_ECB_DECRYPT(token) {
        if(token==''){
            return;
        }
        var decrypt = CryptoJS.AES.decrypt(
            token, 
            CryptoJS.enc.Utf8.parse(this.key),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        return decrypt.toString( CryptoJS.enc.Utf8 )
    }
    //資料加密
    AES_ECB_ENCRYPT(parameter){
        console.log('AES_ECB_ENCRYPT = ',this.header.token)
        let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(parameter)), CryptoJS.enc.Utf8.parse(this.key), { 
            iv:CryptoJS.enc.Utf8.parse(this.iv),
            mode: CryptoJS.mode.ECB, 
            padding: CryptoJS.pad.Pkcs7
        }); 
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
    }
    //api請求body資料加密
    apiDataEncrypt(parameter){
        if ( this.isDecryption ){ //需要加密
            parameter = {
                data:this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = JSON.stringify(parameter)
        }else{ //資料不需要加密
            // parameter = JSON.stringify(parameter)
        }
        return parameter
    }
    //api回應資料解密
    apiDataDecrypt(parameter){
        if ( this.isDecryption ){ //需要解密
            parameter = JSON.parse( this.AES_ECB_DECRYPT(parameter.data) )
        }
        return parameter
    }
    //處理login&註冊時產生token
    userInputEncrypt(){
        let token = CryptoJS.lib.WordArray.random(128/8).toString(CryptoJS.enc.Hex)
        return token
    }
    //get加密
    getMethodEncryp(parameter){
        if ( this.isDecryption ){ //需要加密
            parameter = {
                data:this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = "data="+parameter
        }else{ //資料不需要加密
            // parameter = JSON.stringify(parameter)
            let url = ''
            Object.keys(parameter).forEach((key) => {
                url = url+key+'='+parameter[key]+'&'
            });
            parameter =  url.substring(0, url.length - 1);
        }
        return parameter
    }
    //執行POST
    postApi(data){ 
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            // contentType : 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function(res){
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                data.success(res)
            },
            xhr: function(){
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function(progressEvent){ // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete*100);
                        if ( data.progress ){
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total); 
                            data.progress({
                                mag:"上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total,
                                loaded:progressEvent.loaded,
                                total:progressEvent.total,
                                percentComplete:percentComplete,
                                percentVal:percentVal
                            })
                        }   
                    }
                },false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function(){
                // alert('error[500] : serveer error')
                data.success({code:500})
            }
        })
    }
    postFormDataApi(data){ 
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            data:data.parameter,  // 將表單資料用打包起來送出去
            contentType: false,
            cache: false,
            processData:false,
            success: function(res){
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if(res.code==-9999){
                    alert(res.msg);
                }
                data.success(res)
            },
            xhr: function(){
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function(progressEvent){ // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete*100);
                        if ( data.progress ){
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total); 
                            data.progress({
                                mag:"上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total,
                                loaded:progressEvent.loaded,
                                total:progressEvent.total,
                                percentComplete:percentComplete,
                                percentVal:percentVal
                            })
                        }   
                    }
                },false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function(res){

                console.log(`res=` , res)
                
                // alert('error[500] : serveer error')
                data.success({code:500})
            }
        })
    }
    //執行PUT
    putApi(data){
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'PUT',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            contentType : 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function(res){
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                data.success(res)
            },
            xhr: function(){
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function(progressEvent){ // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete*100);
                        if ( data.progress ){
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded/progressEvent.total)*100+'%'); 
                            data.progress({
                                mag:"上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded/progressEvent.total)*100+'%',
                                loaded:progressEvent.loaded,
                                total:progressEvent.total,
                                percentComplete:percentComplete,
                                percentVal:percentVal
                            })
                        }   
                    }
                },false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function(){
                // alert('error[500] : serveer error')
                data.success({code:500})
            }
        })
    }
    //執行GET
    getApi(data){
        // {url,parameter,callback}
        console.log("header");
        console.log(this.header);
        console.log(data.url);
        let self = this
        if (data.parameter){
            data.url = data.url+"?"+this.getMethodEncryp(data.parameter)
        }
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'GET',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            success: function(res){
                // 成功以後會執行這個方法
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if(res.code==-9999){
                    alert(res.msg);
                }
                data.success(res)
            },
            error: function(){
                // alert('error[500] : serveer error')
                data.success({code:500})
            }
        })
    }

    //執行GET
    getFormApi(data){
        // {url,parameter,callback}
        console.log("header");
        console.log(this.header);
        console.log(data.url);
        let self = this
        
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'GET',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            data:data.parameter,  // 將表單資料用打包起來送出去
            contentType: false,
            cache: false,
            processData:false,
            success: function(res){
                // 成功以後會執行這個方法
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if(res.code==-9999){
                    alert(res.msg);
                }
                data.success(res)
            },
            error: function(){
                // alert('error[500] : serveer error')
                data.success({code:500})
            }
        })
    }

    //執行DELECT
    delApi(data){
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'DELETE',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers:self.header,
            contentType : 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function(res){
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if(res.code==-9999){
                    alert(res.msg);
                }
                data.success(res)
            },
            error: function(){
                alert('error[500] : serveer error')
                data.success({code:500})
            }
        })
    }

    /*
    api區
    */
    //取得測試資料
    getTestTableAPI(parameter,callback){
        //呼叫post方法
        this.getApi({
            url:this.url+"patient/list",
            parameter:parameter,
            success:function(res){
                callback(res)
            }
        })
    }

    //user - 1.1登入 f
    async set_training_records(parameter){
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url:this.url+"set_training_records",
                parameter:parameter,
                success:function(res){
                    // alert('set_training_records success')
                    resolve(res)
                },
                error:(err)=>{
                    // alert('set_training_records error')
                    reject({code:500})
                }
            })
        })
    }
    async set_ai_training_day(email,latestTrainingRecord){
        return new Promise((resolve, reject) => {

            let formData = new FormData();
            formData.append('email', email);
            formData.append('app_name', 'brainrich');
            formData.append('training_type', latestTrainingRecord.training_type);

            this.postFormDataApi({
                url:this.url+"set_ai_training_day",
                parameter:formData,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
        


    }

    async setTrainingRecords(latestTrainingRecord){
        
        const user = JSON.parse(localStorage.getItem('login_info')) || {};
        let email = ""

        if ( 
            process.env.VUE_APP_TEST_ENV == 'community'
        ){
            email = user.member_id;
        } else if ( 
            process.env.VUE_APP_TEST_ENV == 'table'
        ){
            if (!latestTrainingRecord.member_id){
                return
            }
            email = latestTrainingRecord.member_id
        } else {
            email = shared.newEncrypt(user.email);
        }
        let formData = new FormData();
        formData.append('email', email);
        formData.append('app_name', 'brainrich');
        formData.append('training_type', latestTrainingRecord.training_type);
        formData.append('training_date', latestTrainingRecord.training_date);
        formData.append('training_time', latestTrainingRecord.training_time);
        formData.append('total_number', latestTrainingRecord.total_number);
        formData.append('answer_number', latestTrainingRecord.answer_number);
        formData.append('fraction', latestTrainingRecord.fraction);
        formData.append('difficulty', latestTrainingRecord.difficulty+1);
        formData.append('ans_level', latestTrainingRecord.ans_level);
        formData.append('ans_time', latestTrainingRecord.ans_time);
        
        let trainingRes = await this.set_training_records(formData);
        console.log('trainingRes = ', trainingRes);
        // alert('stop')
        if ( trainingRes.code !== '10000' ){
            return trainingRes;
        }
        //App每日訓練訓練完畢，告知雲端已做完的項目
        const ai_training_res = await this.set_ai_training_day(email,latestTrainingRecord)
        console.log('ai_training_res', ai_training_res);
        return trainingRes;
    }

    async get_detection_status(parameter){
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url:this.url+"get_detection_status",
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }

    async get_training_norm(parameter){
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url:this.url+"get_training_norm",
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }

    async get_member_service(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url:this.url+"get_member_service",
                parameter:parameter,
                success:function(res){
                    console.log(res.code)
                    if ( res.code === 500 ){
                        res.data = localStorage.getItem("service") ? JSON.parse(localStorage.getItem("service")) : []
                    }
                    resolve(res)
                },
                error:(err)=>{
                    reject(err)

                }
            })
        })
    }

    async get_training_records(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url:this.url+"get_training_records",
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }

    async get_ai_training_day(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url:this.url+"get_ai_training_day",
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }

    //https://health.ideabus.net/spoz/api_thirdparty/get_member_info/msRG6kQQA6HoIpsMnhC9qsmvZBl4Z
    async get_member_info(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                // url:`${this.url}get_member_info`,
                url:`${this.base_url}api_thirdparty/get_member_info/msRG6kQQA6HoIpsMnhC9qsmvZBl4Z`,
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }


    //9-19
    async set_contract(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url:this.url+"set_contract",
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
        
    }

    async get_member_base(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                // url:`${this.url}get_member_info`,
                url:`${this.url}get_member_base`,
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }

    async get_member_info_purchase_link(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                // url:`${this.url}get_member_info`,
                url:`${this.url}get_member_info`,
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }

    async getAreaUserList(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                // url:`${this.url}get_member_info`,
                url:`${this.url}area_login`,
                parameter:parameter,
                success:function(res){
                    if ( res.code === 500 ){
                        res.data = localStorage.getItem('communityUserList') ? JSON.parse(localStorage.getItem('communityUserList')) : []
                    }
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }

    async updateAreaUser(parameter){
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                // url:`${this.url}get_member_info`,
                url:`${this.url}edit_member`,
                parameter:parameter,
                success:function(res){
                    resolve(res)
                },
                error:(err)=>[
                    reject(err)
                ]
            })
        })
    }
}
export default ApiService